{
  "version": 1,
  "asset_id": "f912997d-3dc7-481d-94a7-512ccc05b314",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/f912997d-3dc7-481d-94a7-512ccc05b314/libera3.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/f912997d-3dc7-481d-94a7-512ccc05b314/libera3.webp",
  "original_filename": "libera3.webp",
  "size": 29064,
  "content_type": "image/webp",
  "created_at": "2026-08-07T09:36:49Z"
}
